import {tabClick} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withTabClickEvent = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, tabClick, options)

export default withTabClickEvent
